<template>
  <span>
    <v-card-title
      v-if="showTitle"
      class="pl-6 pr-0 d-flex align-center text-title-medium"
      :class="{'py-4' : !showClose}"
    >
      <v-tooltip
        :disabled="!enableRefresh"
        location="bottom"
      >
        <template #activator="{ props }">
          <v-img
            v-if="showIcon"
            :src="keyprodRed"
            class="mr-2"
            max-height="1.1rem"
            max-width="1.1rem"
            min-height="1.1rem"
            min-width="1.1rem"
            sizes="'1.1rem'"
            v-bind="props"
            @click="refreshModule()"
          />
        </template>
        <span>
          {{ $t('module.refresh') }}
        </span>
      </v-tooltip>
      <slot name="title">
        <!-- eslint-disable vue/no-v-html -->
        <span
          class="text-truncate kp-header__title text-title-medium"
          v-html="title"
        />
      </slot>
      <KpImageMachine
        v-if="showImage"
        :show-image="showImage"
      />
      <slot name="append-title">
        <v-spacer />
      </slot>
      <v-btn
        v-if="showHelp"
        icon="help no-fill"
        @click="$emit('help')"
      />
      <template v-if="showClose">
        <v-divider
          v-if="showHelp"
          vertical
          class="mx-2"
        />
        <v-btn
          icon="close"
          data-cy="kp-header__close_btn"
          variant="text"
          :loading="loading"
          @click="$emit('cancel')"
        />
      </template>
    </v-card-title>
    <slot
      v-if="showTitle"
      name="append-title-2"
    />
  </span>
</template>
<script>
// eslint-disable-next-line import/extensions
import keyprodRed from '~images/KeyProd-Icon-Red--Transparent-SMALL.png';

import KpImageMachine from '~/components/common/keyprod/KpImageMachine.vue';

export default {
  name: 'KpHeader',
  components: { KpImageMachine },
  props: {
    /**
     * Title of the header
     */
    title: {
      required: false,
      type: String,
      default: '',
    },
    /**
     * Hides or displays the close button
     */
    showClose: {
      type: Boolean,
      default: false,
    },
    /**
     * Hides or displays the Keyprod icon
     */
    showIcon: {
      type: Boolean,
      default: true,
    },
    /**
     * enabled tooltip & click on icon to refresh module
     */
    enableRefresh: {
      type: Boolean,
      default: false,
    },
    showImage: {
      type: String,
      default: null,
    },
    // Show the help button
    showHelp: {
      type: Boolean,
      default: false,
    },
    /**
     * Show the title
     */
    showTitle: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['help', 'refreshModule', 'cancel'],
  data: () => ({
    keyprodRed,
  }),
  methods: {
    /**
     * emit to refresh parent
     */
    refreshModule() {
      if (this.enableRefresh) this.$emit('refreshModule');
    },
  },
};
</script>
<style scoped lang="scss">
.kp-header {
  &__title {
    line-height: normal;
  }
}
</style>
